import type { ConcatExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const concatResolver =
  createSimpleNamedExpressionResolver<ConcatExpression>(
    'concat',
    (values, separator) => values.join(separator ?? '')
  );
